export default __webpack_public_path__ + "static/media/expoindo-4.81cbcb03.jpg";